import React, { useEffect, useRef } from 'react';
import { ArrowRight } from 'lucide-react';
import { useUpsell } from './UpsellContext';
import { warmCheckoutConnection } from '../utils/warmCheckout';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  variant?: 'primary' | 'ghost';
  className?: string;
}
export function CTAButton({
  text = 'QUIERO ACCESO INMEDIATO',
  subtext,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const {
    openUpsell
  } = useUpsell();
  const containerRef = useRef<HTMLDivElement>(null);
  // Warm the checkout connection when this CTA scrolls into view (purchase intent).
  useEffect(() => {
    const el = containerRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) {
        warmCheckoutConnection();
        observer.disconnect();
      }
    }, {
      rootMargin: '0px',
      threshold: 0.1
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const base = variant === 'primary' ? 'bg-olive-600 hover:bg-olive-700 text-cream-50 animate-soft-pulse' : 'bg-cream-50 hover:bg-cream-100 text-olive-700 border-2 border-olive-600';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    openUpsell();
  };
  return <div ref={containerRef} className={`block w-full max-w-md mx-auto group ${className}`} data-id="element-75">
      <button type="button" onClick={handleClick} onMouseEnter={warmCheckoutConnection} onTouchStart={warmCheckoutConnection} onFocus={warmCheckoutConnection} className={`relative w-full font-sans font-semibold text-base md:text-lg py-4 md:py-5 px-6 rounded-full transition-all duration-300 hover:translate-y-[-1px] flex items-center justify-center gap-3 ${base}`} data-id="element-76">
        <span data-id="element-77">{text}</span>
        <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-78" />
      </button>
      {subtext && <p className="text-xs text-ink-600 text-center mt-3 font-medium" data-id="element-79">
          {subtext}
        </p>}
    </div>;
}